import { nonEmptyString } from "./nonEmptyString.js";

export const urlSchema = nonEmptyString.refine((data) => {
	if (data.startsWith("/")) {
		return true;
	}
	return nonEmptyString.url().safeParse(data).success;
}, "Nejedná se o platný odkaz");
